import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

export const optionsToTags = (options: readonly { label: string; value: number }[]): Tag[] => {
    return options.map((option) => ({
        id: option.value,
        name: option.label,
    }));
};
export const tagsToOptions = (tags: Tag[]) => {
    const options =
        tags?.map((tag) => ({
            label: tag.name,
            value: tag.id,
        })) ?? [];
    return options;
};
